import PremiseNotFound from './PremiseNotFound';

export {
  PremiseNotFound
}
